import PropTypes from "prop-types";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import Bilder from "../../Common/Detalj/Bilder";

import { getVentilstillingBilder as getVentilstillingBilderAction } from "../../../actions/ventilstillingerActions";

function VentilstillingsdetailBilderContainer({ ventilstillingId }) {
  const dispatch = useDispatch();
  const images = useSelector(
    (state) =>
      state.ventilstillingerBilder &&
      state.ventilstillingerBilder[ventilstillingId],
  );

  useEffect(() => {
    dispatch(getVentilstillingBilderAction(ventilstillingId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Bilder id={ventilstillingId} imageArray={images} />;
}

VentilstillingsdetailBilderContainer.propTypes = {
  ventilstillingId: PropTypes.string.isRequired,
};

export default VentilstillingsdetailBilderContainer;
